import React, { FC, useMemo } from 'react';
import nextId from 'react-id-generator';
import classNames from 'classnames';
import {
    ASSETS_PATH,
    CARVING_WRITING_HORIZONTAL,
    CARVING_VERTICAL,
    CARVING_HORIZONTAL,
    CARVING_ATTENTION1,
    CARVING_ATTENTION2,
} from '@app/react/const/variables';
import { PartsProduct } from '@app/react/const/type';

export interface MozikokuinThumbnailProps {
    product: PartsProduct | null;
    selected: boolean;
    onClick: (product: PartsProduct) => void;
    disabled: boolean;
}

export const MozikokuinThumbnail: FC<MozikokuinThumbnailProps> = (props) => {
    const {
        product, selected, onClick, disabled,
    } = props;

    const name = product?.name || '';
    const msg = product?.options?.carvingWritingType === CARVING_WRITING_HORIZONTAL
        ? CARVING_HORIZONTAL
        : CARVING_VERTICAL;
    const attention = product?.options?.carvingWritingType === CARVING_WRITING_HORIZONTAL
        ? CARVING_ATTENTION2
        : CARVING_ATTENTION1;
    const label = `${name}${msg} ${attention}`;

    const htmlId = useMemo(() => nextId('order-mozikokuin'), []);
    const labelClassName = classNames('product-thumbnail-yesorno', {
        selected,
    });

    const productImage = product?.productImages[0];

    /* eslint-disable jsx-a11y/label-has-associated-control */
    return (
        <label htmlFor={htmlId} className="tab-string-label">
            <input
                id={htmlId}
                type="radio"
                name="TAB"
                className="tab-color-switch"
            />
            <label className={labelClassName}>
                <input
                    type="radio"
                    name="mozikokuin"
                    onChange={() => {
                        if (product === undefined) {
                            return;
                        }
                        onClick(product);
                    }}
                    disabled={disabled}
                />
                <img
                    className="product-thumbnail-yesorno__catch-text"
                    src={productImage}
                    alt="product thumbnail"
                />
                <p className="product-thumbnail-yesorno__text1">{label}</p>
                <div className="product-thumbnail-yesorno__icon-selected">
                    <img
                        src={`${ASSETS_PATH}/img/common/icon-selected.svg`}
                        alt="選択中"
                    />
                </div>
            </label>
        </label>
    );
    /* eslint-enable jsx-a11y/label-has-associated-control */
};
